import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import { DFPManager } from 'react-dfp';
import exact from 'prop-types-exact';
import { optionalCookiesAllowed } from '../../../helpers/optionalCookies';
import HeaderTags from '../../../common/headerTags/HeaderTags';
import ErrorPage from '../../../common/errorPage/ErrorPage';
import MusicItem from '../../musics/containers/MusicItemContainer';
import Placeholder from '../../../common/placeholder/Placeholder';

const headerTagsJson = require('./headertags.json');

const Top10 = ({ slug, dataCategories, isLoading, dataTop10, withCategory, notFound, getTop10DataIfNeeded }) => {
    const location = useLocation();
    const [currentSlug, setCurrentSlug] = useState(slug || 'antena-1');

    function _mapTop10() {
        if (isLoading) {
            const myLoaderToTop10 = [];

            for (let i = 1; i <= 10; i += 1) {
                myLoaderToTop10.push(
                    <article key={i} className="musicItem">
                        <Placeholder minHeight="100%" />
                    </article>,
                );
            }

            return myLoaderToTop10;
        }

        return dataTop10.map((data, index) => (
            <MusicItem
                music={data}
                key={data.musicId}
                playlistType={`top10-${currentSlug}`}
                playlistData={dataTop10}
                musicIndex={index}
            />));
    }

    // const _handlingButtonGetCategory = useCallback((arrayIndex, categoryId = 1) => {
    //     const slugCategory = arrayIndex ? dataCategories.getIn([arrayIndex, 'categorySlug']) :
    //         dataCategories.find((data) => data.get('categoryId') === (categoryId)).get('categorySlug');

    //     if (slugCategory !== currentSlug) {
    //         history.push(`/as-10-mais/${slugCategory}`);

    //         setTimeout(() => {
    //             animateScrollTo(0, { speed: 700 });
    //         }, 500);
    //     }
    // }, [currentSlug, dataCategories, history]);

    function _metaTags(headerTags) {
        // we use withCategory to check if we are on 10+ page and need to set the header tags
        if (withCategory) {
            return (
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
            );
        }

        return false;
    }

    function _showCategoryDescription() {
        if (withCategory && dataCategories) {
            return dataCategories.map((data) => {
                if (data.categorySlug === currentSlug) {
                    return (
                        <h1 key={data.categoryName}>
                            {data.description}
                        </h1>
                    );
                }

                return false;
            });
        }

        return false;
    }

    // const _mapTop10Category = useCallback(() => {
    //     const activeButtonClass = !isMobile ? 'activeButton' : '';

    //     if (dataCategories.size !== 0) {
    //         return dataCategories.toJS().map((data) => (
    //             <li className="MenuItem" key={data.categorySlug} data-slug={data.categorySlug}>
    //                 <Button
    //                     title={`Mostra as 10+ de ${data.categoryName}`}
    //                     onClick={() => _handlingButtonGetCategory(null, data.categoryId)}
    //                     className={currentSlug === data.categorySlug ? activeButtonClass : ''}
    //                 >
    //                     {data.categoryName}
    //                 </Button>
    //             </li>
    //         ));
    //     }

    //     return false;
    // }, [dataCategories, currentSlug, isMobile, _handlingButtonGetCategory]);

    useEffect(() => {
        if (window.location.pathname === '/as-10-mais') {
            animateScrollTo(0, { speed: 700 });
        }

        getTop10DataIfNeeded(slug);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (optionalCookiesAllowed()) DFPManager.refresh();

        getTop10DataIfNeeded(slug);

        setCurrentSlug(slug || 'antena-1');

        // setCurrentCategoryIndex(dataCategories.toJS().findIndex((data) => data.categorySlug === slug));
    }, [slug, getTop10DataIfNeeded, dataCategories]);

    const title = currentSlug !== 'antena-1' ? currentSlug.toUpperCase() : 'ANTENA 1';
    const headerTags = {
        title: `As 10+ ${title} - Ranking das músicas da rádio`, // | Antena 1 is automatically added by the Headers Tag
        meta: {
            description: `Confira o ranking das 10 músicas ${title} mais pedidas da programação pelos ouvintes.`,
            keywords: headerTagsJson[currentSlug] && headerTagsJson[currentSlug].keywords,
            'og:title': `As 10+ ${title} - Ranking das músicas da rádio`,
            'og:description': `Confira o ranking das 10 músicas ${title} mais pedidas da programação pelos ouvintes.`,
            'og:image': 'https://a1media.antena1.com.br/image/share/as-10-mais.png',
        },
    };

    if (notFound) {
        return <ErrorPage
            errorNumber={404}
            backLink="/as-10-mais"
            title="NÃO ENCONTRAMOS ÁLBUNS PARA ESTA CATEGORIA :("
            message="Mas  temos  vários outros."
            buttonText="Clique aqui para ver outras 10 mais"
        />;
    }

    return (
        <section className="tw-w-full" id="section-top-dez">
            <div className="tw-container tw-m-auto tw-px-5">
                {_metaTags(headerTags)}

                <header className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-p-0">
                    {location.pathname === '/' ? (
                        <React.Fragment>
                            <div className="lg:tw-flex tw-justify-between tw-items-center tw-w-full tw-py-4 titleTop10">
                                <h2 className="tw-normal-case tw-text-2xl tw-font-normal tw-text-left tw-mb-0 tw-text-black">As 10+</h2>
                                <p className="tw-text-gray-600 m-0">
                                    No destaque da semana trazemos as 10 mais pedidas pelos ouvintes!
                                </p>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <h2 className="tw-text-sm tw-mb-0 tw-font-semibold tw-text-gray-600">
                                {currentSlug.toUpperCase()}
                            </h2>
                            {_showCategoryDescription()}
                            <p className="tw-text-gray-600 m-0">
                                No destaque da semana trazemos as 10 mais pedidas pelos ouvintes!
                            </p>
                        </React.Fragment>
                    )}
                </header>

                <div className="tw-grid tw-w-full tw-bg-slate-100 tw-px-5 tw-pt-5 tw-pb-3 tw-py-5 tw-grid-cols-2 md:tw-grid-cols-4 xl:tw-grid-cols-5 tw-gap-4 tw-place-items-center sm:tw-place-items-center">
                    {_mapTop10()}
                </div>
            </div>
        </section>
    );
};

Top10.propTypes = exact({
    slug: PropTypes.string,
    getTop10DataIfNeeded: PropTypes.func,
    dataTop10: PropTypes.arrayOf(PropTypes.object),
    dataCategories: PropTypes.arrayOf(PropTypes.object),
    withCategory: PropTypes.bool,
    notFound: PropTypes.bool,
    isLoading: PropTypes.bool,
});

export default Top10;
